import { render, staticRenderFns } from "./DVideoPlayer.vue?vue&type=template&id=8e17934c&scoped=true&"
import script from "./DVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./DVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DVideoPlayer.vue?vue&type=style&index=0&id=8e17934c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e17934c",
  null
  
)

export default component.exports